import React from "react";
import TabbedPage from '../../../Elements/TabbedPage';
import ClientLineItemDetailsInfoTab from "./ClientLineItemDetailsInfoTab";

export default class ClientLineItemDetails extends React.Component {
    static defaultProps = {};

    urlParams = new URLSearchParams(window.location.search);
    lineItemId = this.urlParams.get('id');

    tabs = [
        { label: "Information", id: "info", icon: "fa-solid fa-info", component: <ClientLineItemDetailsInfoTab /> },
    ];

    render() {
        return (
            <div className="contentwrapper">
                <TabbedPage tabs={this.tabs} />
            </div>
        );
    }
}

